export class Products {
    constructor(){}
    productID: string;
    productName: string;
    productPrice: string;
    sku: string;
    parentId: number;
    minQuantity:number;
    maxQuantity:number;
  }
  